const SESSION_KEY = "pre_registration_session_id";
import { safeGetItem, safeSetItem, safeRemoveItem } from "@/lib/safeStorage";

export function getSessionId(): string {
  if (typeof window === "undefined") return "";
  let sessionId = safeGetItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = generateSessionId();
    safeSetItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

export function clearSessionId(): void {
  if (typeof window !== "undefined") {
    safeRemoveItem(SESSION_KEY);
  }
}

function generateSessionId(): string {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).substring(2, 10);
  return `${timestamp}-${random}`;
}